module.exports = __webpack_public_path__ + "img/liveclient20210809.bb35ee2b.png";